import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';

@Injectable()
export class AnalyticsService {

    constructor(
      private http: HttpClient,
    ) { }


    getYearCA(year: number) {
        return this.http.get<any>(`${environment.apiUrl}/stats/ca/${year}`).toPromise();
    }

    getAll() {
        return this.http.get<any>(`${environment.apiUrl}/stats/all`).toPromise();
    }

    getVentes() {
        return this.http.get<any>(`${environment.apiUrl}/stats/ventes`).toPromise();
    }

    getResas() {
        return this.http.get<any>(`${environment.apiUrl}/stats/reservations`).toPromise();
    }

    getTransacs(range: string = 'DAY') {
        return this.http.get<any>(`${environment.apiUrl}/stats/transactions?range=${range}`).toPromise();
    }

    getStats(range: string = 'DAY', date?: moment.Moment) {
      return this.http.get<any>(`${environment.apiUrl}/stats/mobile/all?range=${range}&d=${date.format('YYYY-MM-DD')}`).toPromise();
    }

    getDetails(productId: string, date?: string, time?: string) {
        return this.http.get<any>(`${environment.apiUrl}/stats/comments?p=${productId}&d=${date}&t=${time}`);
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/analytics/analytics.service.ts